/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractGuaranteeDto
 */
export interface ContractGuaranteeDto {
    /**
     * 
     * @type {string}
     * @memberof ContractGuaranteeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ContractGuaranteeDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractGuaranteeDto
     */
    isRequired: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContractGuaranteeDto
     */
    fileId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractGuaranteeDto
     */
    isCovered: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ContractGuaranteeDto
     */
    startDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ContractGuaranteeDto
     */
    description: string;
}

/**
 * Check if a given object implements the ContractGuaranteeDto interface.
 */
export function instanceOfContractGuaranteeDto(value: object): value is ContractGuaranteeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isRequired' in value) || value['isRequired'] === undefined) return false;
    if (!('fileId' in value) || value['fileId'] === undefined) return false;
    if (!('isCovered' in value) || value['isCovered'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function ContractGuaranteeDtoFromJSON(json: any): ContractGuaranteeDto {
    return ContractGuaranteeDtoFromJSONTyped(json, false);
}

export function ContractGuaranteeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractGuaranteeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isRequired': json['isRequired'],
        'fileId': json['fileId'],
        'isCovered': json['isCovered'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'description': json['description'],
    };
}

export function ContractGuaranteeDtoToJSON(json: any): ContractGuaranteeDto {
    return ContractGuaranteeDtoToJSONTyped(json, false);
}

export function ContractGuaranteeDtoToJSONTyped(value?: ContractGuaranteeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'isRequired': value['isRequired'],
        'fileId': value['fileId'],
        'isCovered': value['isCovered'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'description': value['description'],
    };
}

